import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
import TimeWorkingHours from "./TimeWorkingHours";

class WorkingHours extends Component {
    state = {
        week: {
            'Sunday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: false, },
            'Monday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Tuesday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Wednesday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Thursday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Friday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: true },
            'Saturday': { timing: [{ start: '9:00', end: '18:00', id: nanoid() }], locked: false },
        },
        moment: require('jalali-moment'),
        item: {
            start: '00:00',
            end: '23:59',
            repeat: '00:10'
        },
        time: [],
        currentTime: '',
        locked: {},
        lockBox: false,
        setTheTime: false,
        checkBox: {}
    }

    
    componentDidMount() {
        this.generateTime()
        this.setWeek()
    }


    componentDidUpdate(prevProps){

        if(this.props.data != prevProps.data){
            this.setWeek()
        }

    }

    generateTime = () => {
        let startRepeat = this.state.moment.duration(this.state.item.start).asMinutes()
        let endRepeat = this.state.moment.duration(this.state.item.end).asMinutes()
        let repeat = this.state.moment.duration(this.state.item.repeat).asMinutes()
        let time = this.state.time
        let promises = []
        for (let j = startRepeat; j <= endRepeat; j += repeat) {
            promises.push(new Promise((resolve) => {
                let minutes = j % 60;
                minutes = String(minutes).padStart(2, '0')
                let hours = (j - minutes) / 60;
                hours = String(hours).padStart(2, '0')
                time.push(hours + ":" + minutes)
                resolve()
            }))
        }
        Promise.all(promises).then(() => {
            this.setState({ time })
        })
    }

    setWeek = () => {
        console.log(this.props.data)
        if (this.props.data) {
            this.setState({ week: this.props.data })
        }
    }



    setTiming = () => {
        const setTheTime = this.state.setTheTime
        this.setState({ setTheTime: !setTheTime })
    }
    addTimeBox = (key) => {
        let week = this.state.week
        week[key].timing.push({ start: '9:00 am', end: '6:00 pm', id: nanoid() })
        this.changeValue(week)
    }
    deleteTimeBox = (key, index) => {
        let week = this.state.week
        week[key].timing.splice(index, 1)
        this.changeValue(week)
    }
    lockInput = (key) => {
        let week = this.state.week
        week[key].locked = !week[key].locked
        this.changeValue(week)
    }
    setData = (key, value) => {
        console.log(key, value)
        this.setState({ [key]: value })
    }
    updateWeek = (key, value, type, index) => {
        let week = this.state.week

        week[key].timing[index][type] = value
        if (type == 'start' && week[key].timing[index]['end'] <= value) {
            week[key].timing[index]['end'] = null
            // console.log("HERE")
        }
        // console.log(week)


        this.changeValue(week)

    }


    changeValue = (week) => {

        this.setState({ week })

        console.log(week)

        this.props.changeValue(this.props.header.key, week, this.props.extra)

    }


    render() {
        return (
            <div className="working-hours scroll-no-scrollbar">
                {Object.entries(this.state.week).map(([key, value], index) => {
                    return (
                        <div className=" d-flex" key={key} >
                            <div className="d-flex flex-1" style={{ alignItems: 'flex-start', marginTop: '15px' }} onClick={() => this.lockInput(key)}>
                                <input type="checkbox" id="days"
                                    className="hour-checkbox mt-1" checked={value.locked} />
                                <p className="days">{key}</p>
                            </div>
                            <div>


                                {value.timing.map((item, num) => {
                                    return (

                                        <div className="flexc flex-1" key={item.id}>

                                            <TimeWorkingHours data={item.start} locked={value.locked} type={'start'} time={this.state.time} startEnd={item.start} setData={this.setData} weekKey={key} index={num} updateWeek={this.updateWeek} currentTime={this.state.currentTime} />
                                            <p className="flexcc">&nbsp;-&nbsp;</p>
                                            <TimeWorkingHours data={item.end} locked={value.locked} startTime={item.start} type={'end'} time={this.state.time} startEnd={item.end} setData={this.setData} weekKey={key} index={num} updateWeek={this.updateWeek} currentTime={this.state.currentTime} />
                                            <div className="d-flex" style={{ alignItems: 'flex-end', width: '40px' }}>
                                                <div style={{ width: '20px' }}>
                                                    {num == value.timing?.length - 1 && (
                                                        <img width={15} src="/assets/icons/plus.svg" style={{ opacity: '70%', display: !value.locked && 'none' }} onClick={() => this.addTimeBox(key)} />
                                                    )}
                                                </div>
                                                <div style={{ width: '20px' }}>
                                                    {value.timing?.length != 1 && (
                                                        <img width={15} src="/assets/icons/trash.svg" style={{ opacity: '70%' }} onClick={() => this.deleteTimeBox(key, num)} />
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    )
                                })}
                                {/* </div> */}
                            </div>
                            {/* {value.locked && */}

                            {/* } */}
                        </div>
                    )
                })
                }
                {/* {this.state.setTheTime == true &&
                    <div className="set-time scroll-no-scrollbar ">
                        {this.state.time.map((item, index) => {
                            return (
                                <div className="set-time-item" style={{}}>
                                    {item}
                                </div>
                            )
                        })}
                    </div>
                } */}
            </div >
        );
    }

}

export default WorkingHours;